import { getByDictKeyAndDictLabel } from '@/api/system/dictDetail'
import _ from 'lodash'

/**
 * 打开表格列设置弹窗
 * @param {Object} refTable el-table 组件的 ref
 * @param {String} tableColumnRefName TableColumnSettingDialog 组件的 ref 名称
 */
export function openTableColumnSettingDialog(refTable, tableColumnRefName = 'tableColumnSettingDialog') {
  const ref = this.$refs[tableColumnRefName]
  if (!ref) {
    throw new Error('tableColumnSettingDialog ref is not found')
  }
  ref.open(refTable)
}

export const openNewWindow = (router, params) => {
  let routeData = router.resolve(params);
  window.open(routeData.href, '_blank');
}

/**
 * 解析当前route中的某个参数
 * @param {Object} route 当前route对象
 * @param {String} paramKey 参数key
 * @returns {String}
 */
export function parseCurrentRouteParam(route, paramKey) {
  const { params } = route
  if (params && params[paramKey]) {
    return params[paramKey]
  }
  return null
}
export function parseBusinessTypeParam() {
  const businessTypeAlias = parseCurrentRouteParam(this.$route, 'type')
  const businessType = this.$enumsConvertToList(this.$enums.BUSINESS_TYPE).find(item => item.alias === businessTypeAlias).value
  return businessType
}

/**
 * 解析业务类型
 * @returns 业务类型
 */
export function parseBusinessType() {
  // 从当前路由uri中解析最后一个/后的值，并从$enums.BUSINESS_TYPE.[].alias 检查是否能匹配到，如果匹配到，用BUSINESS_TYPE.[].value 作为返回值
  const businessTypeAlias = this.$route.path.split('/').pop()
  const buEnum = this.$enumsConvertToList(this.$enums.BUSINESS_TYPE).find(item => item.alias === businessTypeAlias)
  if (buEnum) {
    return buEnum.value
  }
  return null
}
export function parseBusinessTypeAlias() {
  // 从当前路由uri中解析最后一个/后的值，并从$enums.BUSINESS_TYPE.[].alias 检查是否能匹配到，如果匹配到，用BUSINESS_TYPE.[].value 作为返回值
  const businessTypeAlias = this.$route.path.split('/').pop()
  const businessType = this.$enumsConvertToList(this.$enums.BUSINESS_TYPE).find(item => item.alias === businessTypeAlias).value
  return businessType
}
/**
 * 解析业务类型 内外贸
 * @returns 业务类型
 */
export function parseBusinessCategoryAlias() {
  // 从当前路由uri中解析最后一个/后的值，并从$enums.BUSINESS_TYPE.[].alias 检查是否能匹配到，如果匹配到，用BUSINESS_TYPE.[].value 作为返回值
  const businessCategoryAlias = this.$route.path.split('/').pop()
  const businessCategory = this.$enumsConvertToList(this.$enums.BUSINESS_CATEGORY).find(item => item.alias === businessCategoryAlias).value
  return businessCategory
}

/**
 * 根据businessType value 转换成 label
 * @param {*} businessTypeValue 值
 * @returns businessTypeLabel
 */
export function businessTypeValueToAlias(businessTypeValue) {
  const businessType = this.$enumsConvertToList(this.$enums.BUSINESS_TYPE).find(item => item.value === businessTypeValue)
  return businessType?.alias || businessTypeValue
}

/**
 * 获取字典配置的默认值
 * @param {String} dictLabel 字典label
 * @param {Boolean} parseInt 是否转换为整数, 默认true
 * @returns {String} 字典value
 */
export async function getDictDefault(dictLabel, parseInt = true) {
  const res = await getByDictKeyAndDictLabel('defaultValue', dictLabel)
  return parseInt ? _.toInteger(res.data.dictValue) : res.data.dictValue
}